// The app's storage helpers. These now delegate to the platform seam
// (D-133; plan: 02_ENGINEERING/Platform_Abstraction_Plan.md) so the same call
// sites work in both shells — chrome.storage.local in the extension, IndexedDB
// in the web/PWA build. The real per-shell implementation lives in
// lib/platform/*. One place every store reads from and writes to, as before.
import { platform } from "./platform/index.js";

export function storageGet<T>(key: string, fallback: T): Promise<T> {
  return platform.storage.get(key, fallback);
}

export function storageSet<T>(key: string, value: T): Promise<void> {
  return platform.storage.set(key, value);
}

/** Fires whenever `key` changes, from any context. */
export function onStorageChange<T>(key: string, callback: (value: T) => void): () => void {
  return platform.storage.onChange(key, callback);
}

/** Remove one or more stored keys. */
export function storageRemove(keys: string | string[]): Promise<void> {
  return platform.storage.remove(keys);
}

/** Every stored key/value — for a full data export. */
export function storageGetAll(): Promise<Record<string, unknown>> {
  return platform.storage.getAll();
}

/** A tiny event emitter for in-page "this store changed, re-render" signals. */
export class Emitter {
  private listeners = new Set<() => void>();
  subscribe(fn: () => void): () => void {
    this.listeners.add(fn);
    return () => this.listeners.delete(fn);
  }
  emit(): void {
    for (const fn of this.listeners) fn();
  }
}
